import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UntypedFormBuilder, FormControl, FormGroup } from '@angular/forms'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { leaseTransferViewModel } from '../../../../models/leaseTransferViewModel'
import { LeaseTransferSummary } from '../../../../models/leaseTransferSummary'
import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'
import { RequestSummaryLeaseTransferModalComponent } from '../../../modals/request-summary-lease-transfer-modal/request-summary-lease-transfer-modal.component'

@Component({
    selector: 'app-request-lease-transfer-detail',
    templateUrl: './request-lease-transfer-detail.component.html',
    styleUrls: ['./request-lease-transfer-detail.component.scss'],
    standalone: false
})
export class RequestLeaseTransferDetailComponent implements OnInit 
{
  isActiveLease: boolean = true

  referenceNumber: string = ''
  leaseTransferViewModel = new leaseTransferViewModel()
  customerName: string = ''

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.retrieveLeaseTransferRequestViewModel()
  }

  retrieveLeaseTransferRequestViewModel()
  {
    this.messageService.startedHttpRequest('retrieveLeaseTransferRequestViewModel')
    this.customerRequestsService
      .getLeaseTransferRequestViewModel()
			.subscribe({
				next: (apiResponse) =>
        {
          this.leaseTransferViewModel = apiResponse

          if(this.leaseTransferViewModel && this.leaseTransferViewModel.isActiveLease)
          { 
            this.customerName = this.siteService.customerAccount?.fullName ?? ''
          }
          else
          {
            this.isActiveLease = false
          }
        },
				error: (error) =>
				{
          this.isActiveLease = false
          this.messageService.completedHttpRequest('retrieveLeaseTransferRequestViewModel')
      
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('retrieveLeaseTransferRequestViewModel')
				}
			})
  }

  submitForm()
  {
      let changeRequest =
      {
      }

      this.messageService.startedHttpRequest('submitForm')
      this.customerRequestsService
      .addLeaseTransferRequest(changeRequest)
			.subscribe({
				next: (apiResponse) =>
        {
          this.referenceNumber = apiResponse

          if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
          {
            let leaseTransferSummary = new LeaseTransferSummary()
            leaseTransferSummary.referenceNumber = this.referenceNumber
            leaseTransferSummary.customerName = this.siteService.customerAccount?.fullName ?? ''
            leaseTransferSummary.leaseNumber = this.leaseTransferViewModel.leaseNumber
            leaseTransferSummary.dealerName = this.leaseTransferViewModel.dealerName
            leaseTransferSummary.dealerAddress = this.leaseTransferViewModel.dealerAddress
            leaseTransferSummary.dealerPhone = this.leaseTransferViewModel.dealerPhone

            this.requestLeaseTransferSummary(this.referenceNumber, leaseTransferSummary)
          
            this.router.navigate(['/request-list'])
          }	
        },
				error: (error) =>
				{
          this.messageService.completedHttpRequest('submitForm')
    
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('submitForm')
				}
			})
  }

  requestLeaseTransferSummary(referenceNumber: string, leaseTransferSummary:any)
  {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px',
      dialogConfig.data = {
        referenceNumber: referenceNumber,
        leaseTransferSummary: leaseTransferSummary
      }
    
      const dialogRef = this.dialog.open(RequestSummaryLeaseTransferModalComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        if(result)
        {
          this.customerRequestsService.extendLoginSession()
        }
        else
        {
          this.siteService.logout()
        }
      })
  }
}
